export default __webpack_public_path__ + "static/media/QC-1U-FRONT.69609682.png";